// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__XgujU","calendarButtons":"ClockData_calendarButtons__3KMQz"};